module.exports = require("@splunk/dashboard-visualizations/utils/eventUtils");